import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Dashboard: React.FC = () => {
  const { state } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect based on role
    if (state.isAuthenticated) {
      if (state.user?.role === 'ADMIN') {
        navigate('/admin', { replace: true });
      } else {
        navigate('/holder', { replace: true });
      }
    } else {
      navigate('/login', { replace: true });
    }
  }, [state.isAuthenticated, state.user?.role, navigate]);

  return <div>Redirecting...</div>;
};

export default Dashboard;
